var _defs, _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneEmailAdd03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/1000/svg",
    viewBox: "0 0 183.35 186.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#86d1d7;}.cls-2{fill:#2e2b7c;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.32,
    y: 12.85,
    width: 160.72,
    height: 160.72,
    rx: 23.65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.62,45.69,81.76,95.77a13.22,13.22,0,0,0,19.84,0L145,46.56a4.79,4.79,0,0,1,1.23-1,15,15,0,0,0-6-1.25h-97a14.88,14.88,0,0,0-5.76,1.15C37.47,45.55,37.55,45.61,37.62,45.69Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.88,51.35a4.55,4.55,0,0,1-.85,1.43L108.66,102a22.64,22.64,0,0,1-34,0L30.56,51.91a2.35,2.35,0,0,1-.23-.32,14.85,14.85,0,0,0-2.16,7.73V127.1a15,15,0,0,0,15,15h97a15,15,0,0,0,15-15V59.32A15,15,0,0,0,152.88,51.35Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneEmailAdd03);
export default __webpack_public_path__ + "static/media/phoneEmailAdd-03.4ff48b9d44280e4795ad89c2f500470a.svg";
export { ForwardRef as ReactComponent };